import request from '@/utils/request'

// 查询合同列表
export function getContractList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contract/queryContract',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询合同类型列表
export function getContractTypeList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contract/queryContractType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询合同规格
export function getContractTypeSpec(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contract/queryContractTypeSpec',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新合同信息
export function updateContract(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contract/updateContract',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除合同
export function deleteContract(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contract/deleteContract',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 上传合同文件
export function uploadContractFile(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contractFile/uploadContactFile',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function queryWordByContract(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contract.getContractWord',
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      timeout: 60000 // 生成文档可能耗时较长，设置超时时间
    }).then(response => {
      console.log('111', response.data)
      const res = response.data;
      resolve(res);
    }).catch(error => {
      reject(error);
    });
  });
}

export function getStaffInfos(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/query.staff.infos',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询房屋列表
export function queryRooms(params) {
  return new Promise((resolve, reject) => {
    request({
      url: "/room.queryRooms",
      method: "get",
      params,
    })
      .then((response) => {
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function queryRoomAmounts(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/room.queryRuleRelCalcValue',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function queryContractNew(params) {
  return new Promise((resolve, reject) => {
    request({
      url: "/contract.queryContractNewCmd",
      method: "get",
      params,
    })
      .then((response) => {
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function updateContractNew(data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/contract.updateContractNewCmd",
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function updatePaymentsByContract(data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/contract.updatePaymentsByContractCmd",
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function queryContractDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: "/contract.QueryPaymentsByContractCmd",
      method: "get",
      params,
    })
      .then((response) => {
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function uploadContractAttachmentRel(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contract.GetPaymentsByContractCmd',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function queryFloorAndUnits(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/floor.queryFloorAndUnits',
      method: 'get',
      params: {
        ...params
      }
    }).then(response => {
      const res = response
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}


export function exportContractExcel(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/export.exportData',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function quitRentContract(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contract.QuitRentContractCmd',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}